import { connect } from "react-redux";
import HomeNavbar from "../../components/navigation/home/HomeNavbar";
import Footer from "../../components/navigation/home/Footer";

function HomeLayout({ children }) {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Header */}
      <header className="sticky top-0 z-50 shadow-sm">
        <HomeNavbar />
      </header>

      {/* Contenido principal */}
      <main className="flex-1 bg-gray-50">
        <div className="min-h-screen">
          {children}
        </div>
      </main>

      {/* Footer */}
      <footer className="mt-auto">
        <Footer />
      </footer>
    </div>
  );
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {})(HomeLayout);
